import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type PropertiesInPostcodeQueryVariables = Types.Exact<{
    postcode: Types.Scalars['String'];
}>;

export type PropertiesInPostcodeQuery = { __typename?: 'Query' } & {
    properties: Array<
        { __typename?: 'Properties' } & Pick<
            Types.Properties,
            'fullAddress' | 'propertyId'
        >
    >;
};

export const PropertiesInPostcodeDocument = gql`
    query propertiesInPostcode($postcode: String!) {
        properties(postcode: $postcode) {
            fullAddress
            propertyId
        }
    }
`;

/**
 * __usePropertiesInPostcodeQuery__
 *
 * To run a query within a React component, call `usePropertiesInPostcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesInPostcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesInPostcodeQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function usePropertiesInPostcodeQuery(
    baseOptions: Apollo.QueryHookOptions<
        PropertiesInPostcodeQuery,
        PropertiesInPostcodeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        PropertiesInPostcodeQuery,
        PropertiesInPostcodeQueryVariables
    >(PropertiesInPostcodeDocument, options);
}
export function usePropertiesInPostcodeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PropertiesInPostcodeQuery,
        PropertiesInPostcodeQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        PropertiesInPostcodeQuery,
        PropertiesInPostcodeQueryVariables
    >(PropertiesInPostcodeDocument, options);
}
export type PropertiesInPostcodeQueryHookResult = ReturnType<
    typeof usePropertiesInPostcodeQuery
>;
export type PropertiesInPostcodeLazyQueryHookResult = ReturnType<
    typeof usePropertiesInPostcodeLazyQuery
>;
export type PropertiesInPostcodeQueryResult = Apollo.QueryResult<
    PropertiesInPostcodeQuery,
    PropertiesInPostcodeQueryVariables
>;
